import API from '../dataApi';

// -- Accounting: Journal Entries -----------------------------------------------
export const getJournalEntries = (params) => API.get('/journal-entries', { params });
export const createJournalEntry = (data) => API.post('/journal-entries', data);
export const deleteJournalEntry = (id, derasarId) => API.delete(`/journal-entries/${id}`, { params: { derasarId } });
export const getLedgerBalanceMap = (derasarId, financialYearId) =>
  API.get('/journal-entries/balances', { params: { derasarId, financialYearId } });
